import React from 'react';
import {Route, Switch} from "react-router-dom";
import * as routes from "../constants/routes";
import {SignIn} from "../pages/SignIn";
import TemplateList from "../pages/Banner/TemplateList";
import AdsPreviewer, {IAdsPreviewerProps} from "../pages/Campaign/AdsPreviewer";
import Ads from "../pages/Campaign/Ads";
import TemplateEditor from "../pages/Banner/TemplateEditor";
import Files from "../pages/Files";
import withTracker from "../components/GA/withTracker";
import Home from '../pages/Home';
import BasicLayout from "./BasicLayout";
import {Page404} from "../pages/404";

function Dashboard() {
    const templateEditor = withTracker(TemplateEditor);
    return (
        <React.Fragment>
            <Switch>
                <Route exact={true} path={routes.HOME} component={withTracker(Home)}/>
                <Route exact={true} path={routes.BANNER_TEMPLATES} component={withTracker(TemplateList)}/>
                <Route path={routes.BANNER_TEMPLATE_EDIT} component={templateEditor}/>
                <Route exact={true} path={routes.FILES} component={withTracker(Files)}/>
                <Route path={routes.FILE_EDITOR} component={withTracker(Files)}/>
                <Route path={routes.ADS} component={withTracker(Ads)}/>
                <Route
                    path={routes.ADS_PREVIEWER}
                    component={withTracker((props: IAdsPreviewerProps) => <AdsPreviewer{...props}/>)}
                />
                <Route path={routes.SIGN_IN} component={withTracker(SignIn)}/>
                <Route component={Page404}/>
            </Switch>
        </React.Fragment>
    );
}

export default Dashboard;
